import Vue from 'vue'
import Router from 'vue-router'
import Cookies from "js-cookie"
import {config} from "@/utils/config/urlConfig"
import Login from '@/views/Login'
import NotFound from '@/views/Error/404'
import Home from '@/views/Home'
import Charts from '@/views/Intro/Charts'
import Intro from '@/views/Intro/Charts'
import Generator from '@/views/Generator/Generator'
import api from '@/http/api'
import store from '@/store'
import { getIFramePath, getIFrameUrl } from '@/utils/iframe'
import authSelet from '@/views/Myvue/authSelet'
import onAuth from '@/views/Myvue/onAuth'
import authVerify from '@/views/Myvue/authVerify'
import ownInfo from '@/views/Myvue/ownInfo'
import authVerifyDetial from '@/views/Myvue/authVerifyDetial'
import authTime from "@/views/Myvue/authTime"
import logQuery from "@/views/Myvue/logQuery"
import tableChart from "@/views/Myvue/tableChart"
import upload from "@/views/Myvue/upload"
import verifyUpload from '@/views/Myvue/verifyUpload'
import regExamine from '@/views/Myvue/regExamine'
import yzApply from '@/views/Myvue/yuzhoushiApply'
import wfApply from '@/views/Myvue/weifangshiApply'
import wfReg from '@/views/Myvue/weifangshiReg'
import wxPush from "@/views/Myvue/wxPush"
import Flow from '@/views/Myvue/flow'
import authPush from '@/views/Myvue/authPush'
import agePush from '@/views/Myvue/agePush'
import authCondition from '@/views/Myvue/authCondition'
import pushRecord from '@/views/Myvue/pushRecord'
import CrossFile from '@/views/Myvue/CrossFile'
import censusCharts from '@/views/Myvue/censusCharts'
import upload_2 from '@/views/Myvue/upload_2'
import upload_3 from '@/views/Myvue/upload_3'
import upload4 from '@/views/Myvue/upload4'
import realMoney from '@/views/Myvue/realMoney'
import redis from '@/views/Myvue/redis'
import personInfo from '@/views/Myvue/personInfo'
import authRate from '@/views/Myvue/authRate'
import checkSurvival  from '@/views/Myvue/checkSurvival.vue'
import withoutReview from '@/views/Myvue/withoutReview'
import withoutReviewQuery from '@/views/Myvue/withoutReviewQuery'
//商城
import msgCollect from '@/views/shangCheng/msgCollect'
import msgSelect from '@/views/shangCheng/msgSelect'
import money from '@/views/Myvue/money'
import liaocheng_qiye from '@/views/shangCheng/liaocheng_qiye'
import msgInfo from '@/views/shangCheng/msgInfo'
import photoList from '@/views/Myvue/photoList'
Vue.use(Router)
const router = new Router({
  routes: [

    {
      path: '/',
      name: '首页',
      component: Home,
      children: [
        {
          path: '/redis',
          name: 'redis操作',
          component: redis
        },
        {
          path: '/personInfo',
          name: '基本信息查询',
          component: personInfo
        },
        {
          path: '/intro',
          name: '数据统计',
          component: Intro
        },
        {
          path: '/Charts',
          name: '首页',
          component: Charts
        },
        {
          path: '/authselet',
          name: '认证查询',
          component: authSelet,
        },
        {
          path: '/onAuth',
          name: '认证通知',
          component: onAuth,
        },
        {
          path: '/ownInfo',
          name: '个人信息',
          component: ownInfo,

        },{
          path: '/authVerify',
          name: '认证审核',
          component: authVerify,


        },{
          path: '/authVerifyDetial',
          name: '人工审核',
          component: authVerifyDetial,

        },{
          path: '/authTime',
          name: '认证时间设置',
          component: authTime
        },{
          path: '/logQuery',
          name: '操作日志',
          component: logQuery
        },{
          path: '/tableChart',
          name: '津贴查询',
          component: tableChart
        },{
          path: '/upload',
          name: '导入',
          component: upload
        },{
          path: '/verifyUpload',
          name: '认证信息导出',
          component: verifyUpload,
        },{
          path: '/regExamine',
          name: '登记信息审核',
          component: regExamine
        },{
          path: '/0_xuchangshi_yuzhoushi',
          name: '高龄申请',
          component: yzApply
        },{
          path: '/0_weifangshi',
          name: '高龄申请',
          component: wfApply
        },{
          path: '/1_weifangshi',
          name: '高龄登记',
          component: wfReg
        },{
          path: '/wxPush',
          name: '微信推送',
          component: wxPush
        },{
          path:"/flow",
          name:"流程管理",
          component: Flow
        },{
          path:"/authCondition",
          name:"津贴统计",
          component: authCondition
        },{
          path:"/authPush",
          name:"认证短信",
          component: authPush
        },{
          path:"/agePush",
          name:"到龄通知",
          component:agePush
        },{
          path:"/pushRecord",
          name:"推送记录",
          component:pushRecord
        },{
          path:"/CrossFile",
          name:"跨档通知",
          component:CrossFile
        },{
          path:"/censusCharts",
          name:"统计图",
          component:censusCharts
        },{
          path:"/upload_2",
          name:"津贴发放录入",
          component:upload_2
        },{
          path:"/realMoney",
          name:"实发津贴查询",
          component:realMoney
        },{
          path:"/upload_3",
          name:"合伙人信息审核",
          component:upload_3
        },
        {
          path:"/upload4",
          name:"上传停保名单",
          component:upload4
        },
        {
          path:"/msgCollect",
          name:"信息登记",
          component:msgCollect
        },{
          path:"/money",
          name:"存钱罐用户列表",
          component:money
        },{
          path:"/msgSelect",
          name:"信息查询",
          component:msgSelect
        },{
          path:"/liaocheng_qiye",
          name:"企保转移",
          component:liaocheng_qiye
        },{
          path:"/msgInfo",
          name:"详细信息",
          component:msgInfo
        },{
          path:"/authRate",
          name:"认证比例",
          component:authRate
        },{
          path:"/photoList",
          name:"照片审核",
          component:photoList
        },{
          path:"/checkSurvival",
          name:"无感认证(大数据挖掘)",
          component:checkSurvival
        },{
          path:"/withoutReview",
          name:"免申即享",
          component:withoutReview,
        },{
          path:"/withoutReviewQuery",
          name:"免申即享",
          component:withoutReviewQuery,
        }

      ]
    },
    {
      path: '/login',
      name: '登录',
      component: Login
    },
    {
      path: '/404',
      name: 'notFound',
      component: NotFound
    },
    {
      path:"/piggyBank",
      name:"存钱罐用户列表",
      component:money
    }
  ]
})
router.beforeEach((to, from, next) => {

    document.title = config.title


  console.log(to.path)
    document.title = config.title
  if(to.path=="/"){
    let typeChars
  var pat;

  var without = false;
  const role = sessionStorage.getItem('roleIds')
  // 假设role是存储的数组字符串，需要先解析
  const roleArray = role ? JSON.parse(role) : [];
  // 检查是否包含57、58、59中的任意一个
  const targetRoles = [57, 58, 59];  //是否是免申即享的角色
  if (roleArray.some(item => targetRoles.includes(item))) {
    without = true;
  }

if(sessionStorage.getItem('list')){
 typeChars=JSON.parse(sessionStorage.getItem('list'))
 if(typeChars.city){
  if(typeChars.city.split(',')[1]=="许昌市"||typeChars.city.split(',')[1]=="潍坊市"||typeChars.city.split(',')[1]=="信阳市"){
    pat=true
  }else{
    pat=false
  }
 }else{
   pat=false
 }
//  console.log(typeChars.city.split(',')[1]=="许昌市"||typeChars.city.split(',')[1]=="潍坊市"||typeChars.city.split(',')[1]=="信阳市")

}else{
  typeChars={}
}
    if(pat){
     // router.push("/intro")
      router.push("/Charts")
    }else if(without){
      router.push("/withoutReview")
    }else{
      router.push("/Charts")
    }
  }else{
  next()
}
  // 登录界面登录成功之后，会把用户信息保存在会话
  // 存在时间为会话生命周期，页面关闭即失效。
  if(localStorage.getItem("token")){
    Cookies.set('token',localStorage.getItem("token"))
  }
  let token = Cookies.get('token')
  let userName = sessionStorage.getItem('user')
  if(!userName){
    token=false
  }
  if (to.path === '/login') {
    // 如果是访问登录界面，如果用户会话信息存在，代表已登录过，跳转到主页
    if(token) {
      next({ path: '/' })
    } else {
      next()
    }
  } else if(to.path === '/piggyBank'){
    next()
  } else{
    if (!token) {
      // 如果访问非登录界面，且户会话信息不存在，代表未登录，则跳转到登录界面
      next({ path: '/login' })
    } else {
      // 加载动态菜单和路由
      addDynamicMenuAndRoutes(userName, to, from)
      next()
    }
  }
})

/**
* 加载动态菜单
*/
function addDynamicMenuAndRoutes(userName, to, from) {
  // 处理IFrame嵌套页面
  handleIFrameUrl(to.path)
  if(store.state.app.menuRouteLoaded) {
    console.log('动态菜单和路由已经存在.')
    return
  }
  api.menu.findNavTree({'userName':userName})
  .then(res => {
    // 添加动态路由
    let dynamicRoutes = addDynamicRoutes(res.data)
    // 处理静态组件绑定路由
    handleStaticComponent(router, dynamicRoutes)
    router.addRoutes(router.options.routes)
    // 保存加载状态
    store.commit('menuRouteLoaded', true)
    // 保存菜单树
    store.commit('setNavTree',res.data)
  }).then(res => {
    api.user.findPermissions({'name':userName}).then(res => {
      // 保存用户权限标识集合
      store.commit('setPerms', res.data)
    })
  })
  .catch(function(res) {
  })
}

/**
 * 处理路由到本地直接指定页面组件的情况
 * 比如'代码生成'是要求直接绑定到'Generator'页面组件
 */
function handleStaticComponent(router, dynamicRoutes) {
  for(let j=0;j<dynamicRoutes.length; j++) {
    if(dynamicRoutes[j].name == '代码生成') {
      dynamicRoutes[j].component = Generator
      break
    }
  }
  router.options.routes[0].children = router.options.routes[0].children.concat(dynamicRoutes)
}

/**
 * 处理IFrame嵌套页面
 */
function handleIFrameUrl(path) {
  // 嵌套页面，保存iframeUrl到store，供IFrame组件读取展示
  let url = path
  let length = store.state.iframe.iframeUrls.length
  for(let i=0; i<length; i++) {
    let iframe = store.state.iframe.iframeUrls[i]
    if(path != null && path.endsWith(iframe.path)) {
      url = iframe.url
      store.commit('setIFrameUrl', url)
      break
    }
  }
}

/**
* 添加动态(菜单)路由
* @param {*} menuList 菜单列表
* @param {*} routes 递归创建的动态(菜单)路由
*/
function addDynamicRoutes (menuList = [], routes = []) {
 var temp = []
 for (var i = 0; i < menuList.length; i++) {
   if (menuList[i].children && menuList[i].children.length >= 1) {
     temp = temp.concat(menuList[i].children)
   } else if (menuList[i].url && /\S/.test(menuList[i].url)) {
      menuList[i].url = menuList[i].url.replace(/^\//, '')
      // 创建路由配置
      var route = {
        path: menuList[i].url,
        component: null,
        name: menuList[i].name,
        meta: {
          keepAlive: true, // 需要被缓存,
          icon: menuList[i].icon,
          index: menuList[i].id
        }
      }
      let path = getIFramePath(menuList[i].url)
      if (path) {
        // 如果是嵌套页面, 通过iframe展示
        route['path'] = path
        route['component'] = resolve => require([`@/views/IFrame/IFrame`], resolve)
        // 存储嵌套页面路由路径和访问URL
        let url = getIFrameUrl(menuList[i].url)
        let iFrameUrl = {'path':path, 'url':url}
        store.commit('addIFrameUrl', iFrameUrl)
      } else {
       try {
         // 根据菜单URL动态加载vue组件，这里要求vue组件须按照url路径存储
         // 如url="sys/user"，则组件路径应是"@/views/sys/user.vue",否则组件加载不到
         let array = menuList[i].url.split('/')
         let url = ''
         for(let i=0; i<array.length; i++) {
            url += array[i].substring(0,1).toUpperCase() + array[i].substring(1) + '/'
         }
         url = url.substring(0, url.length - 1)
         route['component'] = resolve => require([`@/views/${url}`], resolve)
       } catch (e) {}
     }
     routes.push(route)
   }
 }
 if (temp.length >= 1) {
   addDynamicRoutes(temp, routes)
 } else {

 }
 return routes
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js